import { GatsbyBrowser } from 'gatsby'
import './src/styles/global.css'
import { loadSegmentWithConsent } from '@meowwolf/cookie-consent-utils'
import { handleAppView } from './src/utils/browser'

/**
 * Implement Gatsby's Browser APIs in this file.
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

/**
 * On route update handler for Gatsby
 * Track page views with Segment
 * @param location
 * @param prevLocation
 * @returns {void}
 */
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({
  location,
  prevLocation,
}): void => {
  // exit if we don't have a window
  if (typeof window === 'undefined') return

  // only track page views if the page is not the same as the previous page
  if (location.pathname !== prevLocation?.pathname && typeof window.analytics !== 'undefined') {
    window.analytics.page()
  }
}

export const onClientEntry: GatsbyBrowser['onClientEntry'] = (): void => {
  // exit if we don't have a window
  if (typeof window === 'undefined') return

  if (process.env.GATSBY_SEGMENT_WRITE_KEY) {
    window.analytics = loadSegmentWithConsent({ writeKey: process.env.GATSBY_SEGMENT_WRITE_KEY })
  }
  handleAppView()
}
